// The API returns the full dashboard URL, while the embedded SDK expects only the Superset origin.
export const getSupersetDomain = (dashboardUrl?: string | null): string | null => {
	if (!dashboardUrl) return null;

	try {
		return new URL(dashboardUrl).origin;
	} catch {
		return null;
	}
};
